module.exports = __webpack_public_path__ + "img/edit.82ad92eb.svg";